import React from 'react';
import { IconButton, Typography } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import { useApolloClient } from '@apollo/client';
import UserDialog from './TeamDialog';
import AddUserToTeam from './AddUserToTeam';
import ConfirmDelete from './ConfirmDelete';

const TeamActionMenu = ({ team, refetch }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <div>
      <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <MoreVertIcon color="primary" />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        MenuListProps={{ style: { border: '1px solid #c7c7c7', borderRadius: 5 } }}

      >
        <UserDialog team={team} closeMenu={handleClose} />
        <AddUserToTeam team={team} closeMenu={handleClose} refetch={refetch} />
        <ConfirmDelete _id={team._id} closeMenu={handleClose} />
      </Menu>
    </div>
  );
};

export default TeamActionMenu;
